import { ArrowLeft, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import PageMeta from "./components/PageMeta";

const GOOGLE_SCOPE = "https://www.googleapis.com/auth/youtube.upload";

export default function YtVidCreatorPrivacyPage() {
  return (
    <main className="legal-page" lang="fi">
      <PageMeta
        title="YTVidCreatorin tietosuojaseloste | PK-Forensics"
        description="YTVidCreatorin tietosuojaseloste kertoo Google OAuth -tietojen käytöstä, säilyttämisestä, suojaamisesta ja poistamisesta."
      />

      <header className="legal-hero">
        <div className="page-shell legal-hero-inner">
          <Link className="back-link" to="/ytvidcreator">
            <ArrowLeft size={17} /> Takaisin YTVidCreatorin esittelyyn
          </Link>
          <p className="eyebrow"><span />PK-Forensics / Tietosuoja</p>
          <h1>YTVidCreatorin tietosuojaseloste</h1>
          <p className="legal-effective-date">
            <span>Voimaantulo 4.9.2026</span>
            <i aria-hidden="true">·</i>
            <span>Päivitetty 4.9.2026</span>
          </p>
        </div>
      </header>

      <article className="legal-content page-shell">
        <section aria-labelledby="controller-title">
          <span className="legal-section-number" aria-hidden="true">01</span>
          <div>
            <h2 id="controller-title">Rekisterinpitäjä</h2>
            <p><strong>Rekisterinpitäjä:</strong> PK-Forensics</p>
            <p>
              <strong>Yhteydenotot:</strong>{" "}
              <a href="mailto:jarmo@pk-forensics.fi">jarmo@pk-forensics.fi</a>
            </p>
          </div>
        </section>

        <section aria-labelledby="purpose-title">
          <span className="legal-section-number" aria-hidden="true">02</span>
          <div>
            <h2 id="purpose-title">Palvelun tarkoitus</h2>
            <p>
              YTVidCreator on rekisterinpitäjän oma sisällöntuotanto- ja julkaisuautomaatio. Se luo
              uutisaiheisiin perustuvia videoita ja julkaisee hyväksytyn videon käyttäjän erikseen
              valtuuttamalle YouTube-kanavalle. Sama paikallisesti tuotettu videotiedosto voidaan
              lähettää myös määritetylle Telegram-kanavalle.
            </p>
          </div>
        </section>

        <section aria-labelledby="api-title">
          <span className="legal-section-number" aria-hidden="true">03</span>
          <div>
            <h2 id="api-title">Käytettävä Google API -palvelu ja käyttöoikeus</h2>
            <p>
              YTVidCreator käyttää YouTube Data API v3 -rajapintaa ja OAuth 2.0 -valtuutusta.
              Sovellus pyytää käyttöoikeuden:
            </p>
            <p><code className="legal-code">{GOOGLE_SCOPE}</code></p>
            <p>
              Käyttöoikeutta käytetään ainoastaan YTVidCreatorin tuottamien videoiden lataamiseen
              valtuutetulle YouTube-kanavalle sekä latauksen tuloksen käsittelemiseen. Sovelluksen
              nykyinen toteutus ei lue käyttäjän katseluhistoriaa, tilauksia, kommentteja,
              yhteystietoja tai sähköpostiviestejä.
            </p>
          </div>
        </section>

        <section aria-labelledby="data-title">
          <span className="legal-section-number" aria-hidden="true">04</span>
          <div>
            <h2 id="data-title">Käsiteltävät tiedot</h2>
            <p>Sovellus voi käsitellä seuraavia tietoja:</p>
            <ul>
              <li>Google OAuth -käyttö- ja päivitystoken</li>
              <li>valtuutukseen liittyvä OAuth-asiakastunnus</li>
              <li>YouTuben palauttama videotunniste ja videon URL-osoite</li>
              <li>videon otsikko, kuvaus, tagit, näkyvyysasetus ja julkaisun tila</li>
              <li>paikalliset tekniset lokit ja virhetiedot</li>
              <li>paikallisesti tuotettu videotiedosto</li>
            </ul>
            <p>
              Sovellus ei kerää tämän verkkosivuston vierailijoilta Google-tilitietoja eikä tarjoa
              yleisölle Google-kirjautumista.
            </p>
          </div>
        </section>

        <section aria-labelledby="use-title">
          <span className="legal-section-number" aria-hidden="true">05</span>
          <div>
            <h2 id="use-title">Tietojen käyttötarkoitus</h2>
            <p>Tietoja käytetään ainoastaan:</p>
            <ul>
              <li>käyttäjän pyytämän YouTube-valtuutuksen ylläpitämiseen</li>
              <li>valmiiden videoiden lataamiseen oikealle YouTube-kanavalle</li>
              <li>julkaisun onnistumisen tai epäonnistumisen kirjaamiseen</li>
              <li>teknisten virheiden selvittämiseen</li>
              <li>käyttöoikeuden automaattiseen uusimiseen Googlen sallimissa rajoissa</li>
            </ul>
            <p>
              Tietoja ei käytetä mainontaan, käyttäjäprofilointiin, luottopäätöksiin tai
              jälleenmyyntiin.
            </p>
          </div>
        </section>

        <section aria-labelledby="storage-title">
          <span className="legal-section-number" aria-hidden="true">06</span>
          <div>
            <h2 id="storage-title">Tietojen tallennus ja suojaaminen</h2>
            <p>
              OAuth-token ja muut valtuutustiedot tallennetaan paikallisesti rekisterinpitäjän
              hallitsemalle tietokoneelle. Niitä ei tallenneta julkiselle verkkosivustolle eikä
              lähdekoodivarastoon.
            </p>
            <p>
              Julkaisuhistoriaan voidaan tallentaa YouTube-videon tunniste, URL-osoite, kohde, tila
              ja teknisiä metatietoja. Salaisuuksia ei kirjoiteta normaaliin julkaisutietokantaan.
            </p>
            <p>
              Pääsy tuotantokoneelle ja valtuutustiedostoihin rajataan valtuutetuille henkilöille.
              Tiedot suojataan käyttöjärjestelmän käyttöoikeuksilla ja asianmukaisilla teknisillä
              turvatoimilla.
            </p>
          </div>
        </section>

        <section aria-labelledby="disclosure-title">
          <span className="legal-section-number" aria-hidden="true">07</span>
          <div>
            <h2 id="disclosure-title">Tietojen luovuttaminen</h2>
            <p>
              Google-tililtä saatuja tietoja ei myydä, vuokrata eikä luovuteta mainostajille tai
              data-analytiikkapalveluille.
            </p>
            <p>
              Google OAuth -tunnuksia tai Google-tilitietoja ei siirretä Telegramille. Telegramiin
              lähetetään ainoastaan YTVidCreatorin paikallisesti tuottama valmis videotiedosto ja
              siihen liittyvä julkaisukuvaus.
            </p>
            <p>
              YouTube käsittelee sille ladattua videota Googlen omien ehtojen ja
              tietosuojakäytäntöjen mukaisesti.
            </p>
          </div>
        </section>

        <section aria-labelledby="policy-title">
          <span className="legal-section-number" aria-hidden="true">08</span>
          <div>
            <h2 id="policy-title">Google API Services User Data Policy</h2>
            <p>
              YTVidCreatorin Google API -palveluista saamien tietojen käyttö ja mahdollinen
              siirtäminen noudattaa Google API Services User Data Policya ja sen Limited Use
              -vaatimuksia.
            </p>
            <a
              className="legal-external-link"
              href="https://developers.google.com/terms/api-services-user-data-policy"
              target="_blank"
              rel="noreferrer"
            >
              Google API Services User Data Policy <ExternalLink size={16} />
            </a>
          </div>
        </section>

        <section aria-labelledby="retention-title">
          <span className="legal-section-number" aria-hidden="true">09</span>
          <div>
            <h2 id="retention-title">Tietojen säilytysaika</h2>
            <p>
              OAuth-valtuutustiedot säilytetään niin kauan kuin automaattinen YouTube-julkaisu on
              käytössä tai kunnes käyttäjä peruuttaa valtuutuksen.
            </p>
            <p>
              Paikallisia julkaisu- ja virhelokeja säilytetään teknistä ylläpitoa ja auditointia
              varten, kunnes rekisterinpitäjä poistaa ne oman säilytyskäytäntönsä mukaisesti.
            </p>
          </div>
        </section>

        <section aria-labelledby="deletion-title">
          <span className="legal-section-number" aria-hidden="true">10</span>
          <div>
            <h2 id="deletion-title">Valtuutuksen peruuttaminen ja tietojen poistaminen</h2>
            <p>
              Käyttäjä voi peruuttaa YTVidCreatorin Google-käyttöoikeuden Google-tilin yhteyksien
              hallinnassa:
            </p>
            <a
              className="legal-external-link"
              href="https://myaccount.google.com/connections"
              target="_blank"
              rel="noreferrer"
            >
              Google-tilin yhteyksien hallinta <ExternalLink size={16} />
            </a>
            <p>
              Paikallisesti tallennetut OAuth-tokenit ja julkaisutiedot voidaan poistaa
              rekisterinpitäjän järjestelmästä. Poistamista tai tietoja koskevat pyynnöt voi
              lähettää osoitteeseen:{" "}
              <a href="mailto:jarmo@pk-forensics.fi">jarmo@pk-forensics.fi</a>
            </p>
            <p>
              Valtuutuksen peruuttamisen tai tokenin poistamisen jälkeen YTVidCreator ei voi enää
              julkaista uusia videoita YouTube-kanavalle ilman uutta käyttäjän valtuutusta.
            </p>
          </div>
        </section>

        <section aria-labelledby="breach-title">
          <span className="legal-section-number" aria-hidden="true">11</span>
          <div>
            <h2 id="breach-title">Tietoturvaloukkaukset</h2>
            <p>
              Mahdolliset tietoturvaloukkaukset selvitetään viipymättä. Tarvittavat ilmoitukset
              tehdään sovellettavan lainsäädännön ja palveluntarjoajien vaatimusten mukaisesti.
            </p>
          </div>
        </section>

        <section aria-labelledby="changes-title">
          <span className="legal-section-number" aria-hidden="true">12</span>
          <div>
            <h2 id="changes-title">Muutokset tähän selosteeseen</h2>
            <p>
              Tietosuojaselostetta voidaan päivittää, jos sovelluksen toiminta, käytettävät
              rajapinnat tai oikeudelliset vaatimukset muuttuvat. Sivulla näytetään viimeisin
              päivityspäivä.
            </p>
          </div>
        </section>

        <div className="legal-return">
          <Link className="button button-dark" to="/ytvidcreator">
            <ArrowLeft size={17} /> Takaisin YTVidCreatorin esittelyyn
          </Link>
        </div>
      </article>
    </main>
  );
}
